import type { Locale } from "@/lib/i18n";
import { pl, type CSearchTranslations } from "./pl";
import { en } from "./en";
import { de } from "./de";

export const cSearchTranslations: Record<Locale, CSearchTranslations> = { pl, en, de };
export type { CSearchTranslations };
